import { defineMessages } from 'react-intl';

export const webhookEventsMessages = defineMessages({
    webhookEvents: {
        id: 'webhook-events',
        defaultMessage: 'Webhook events',
    },
    webhookEvent: {
        id: 'webhook-event',
        defaultMessage: 'Webhook event',
    },
    topic: {
        id: 'topic',
        defaultMessage: 'Topic',
    },
    webhookId: {
        id: 'webhook-id',
        defaultMessage: 'Webhook ID',
    },
    attemptCount: {
        id: 'attempt-count',
        defaultMessage: 'Attempt count',
    },
    nextRetryAt: {
        id: 'next-retry-at',
        defaultMessage: 'Next retry at',
    },
    lastAttemptedAt: {
        id: 'last-attempted-at',
        defaultMessage: 'Last attempted at',
    },
    pending: {
        id: 'pending',
        defaultMessage: 'Pending',
    },
    sending: {
        id: 'sending',
        defaultMessage: 'Sending',
    },
    delivered: {
        id: 'delivered',
        defaultMessage: 'Delivered',
    },
    failed: {
        id: 'failed',
        defaultMessage: 'Failed',
    },
    exhausted: {
        id: 'exhausted',
        defaultMessage: 'Exhausted',
    },
});
